import ButtonBack from "components/ButtonBack";
import { useState } from "react";
import { Helmet } from "react-helmet";

const metadata = {
  title: "Data Management",
  description: "",
  keywords: "",
};

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Data Management</title>
        <meta name="title" content="Data Management" />
        <meta name="description" content="Data Management" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Data Management" />
        <meta property="og:description" content="Data Management" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Data Management" />
      </Helmet>
      {/* Main Content */}
      <div id="pagePolicy">
        <main>
          <div className="wrapContent">
            <section id="pPolicy">
              <div className="bTitle">
                <h1>นโยบายความเป็นส่วนตัว</h1>
              </div>
              <div className="bContent">
                <h2>ยินดีต้อนรับ!</h2>

                <p>
                บริษัท วินเทอร์อีเจนซี จำกัด ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของคุณ นโยบายความเป็นส่วนตัวฉบับนี้อธิบายถึงแนวปฏิบัติเกี่ยวกับการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิต่าง ๆ ของเจ้าของข้อมูลส่วนบุคคล ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล 
                </p>
                <h2>1. ขอบเขตของนโยบายนี้ </h2>
                <h3>1. ประเภทของข้อมูลส่วนบุคคลที่ประมวลผล: </h3>
                <ul>
                  <li>ชื่อ - นามสกุล , เบอร์โทรศัพท์ และ อีเมล</li>
                </ul>
                <h3>2. ข้อมูลอ่อนไหว: </h3>
                <ul>
                  <li>
                  เราจะไม่ประมวลผลข้อมูลอ่อนไหว เช่น เวชระเบียน ข้อมูลพันธุกรรม ข้อมูลสุขภาพ หรือประวัติอาชญากรรม เว้นแต่ได้รับความยินยอมอย่างชัดเจนจากคุณและเป็นไปตามกฎหมาย
                  </li>
                </ul>
                <h3>3. เว็บไซต์ของบุคคลที่สาม: </h3>
                <ul>
                  <li>
                  นโยบายนี้ไม่ครอบคลุมถึงเว็บไซต์หรือเนื้อหาของบุคคลที่สาม แม้จะมีการลิงก์จากเว็บไซต์ของเรา โปรดตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์เหล่านั้นโดยตรง 
                  </li>
                </ul>
                <h2>2. วัตถุประสงค์ในการเก็บรวบรวมข้อมูล </h2>
                <p>เราประมวลผลข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังนี้:</p>
                <ul>
                  <li>เพื่อมอบรางวัลแก่ผู้ที่กรอกแบบสำรวจเสร็จสิ้น </li>
                  <li>
                  เพื่อดำเนินการวิจัยและวิเคราะห์ทางการตลาดสำหรับ W/E, บริษัทย่อยในกลุ่ม HDY ที่ W/E สังกัดอยู่ (ซึ่งต่อไปนี้จะเรียกว่า "HDY") รวมถึงแต่ไม่จำกัดเฉพาะ Hakuhodo DY Holdings Inc. (https://www.hakuhodody-holdings.co.jp/english/) และลูกค้าของบริษัทย่อยเหล่านั้น
                  </li>
                  <li>เพื่อดำเนินกิจกรรมการโฆษณาและการตลาดสำหรับ W/E, บริษัทย่อยในกลุ่ม HDY และลูกค้าของบริษัทย่อยเหล่านั้น 
                  </li>
                  <li>เพื่อดำเนินกิจกรรมการวิจัยและพัฒนาสำหรับ W/E และบริษัทย่อยในกลุ่ม HDY</li>
                  <li>เพื่อให้คำปรึกษาและบริการอื่น ๆ </li>
                  <li>เพื่อจัดการเรื่องที่เกี่ยวข้องในข้อ 1 ถึง 5 </li>
                </ul>
                <h2>3. ระยะเวลา สถานที่ และวิธีการประมวลผล </h2>
                <h3>1. ระยะเวลา: </h3>
                <ul>
                  <li>
                  เราจะเก็บรักษาข้อมูลของคุณเท่าที่จำเป็นสำหรับวัตถุประสงค์ที่ระบุไว้ หรือเท่าที่กฎหมายกำหนด 
                  </li>
                </ul>
                <h3>2. สถานที่: </h3>
                <ul>
                  <li>
                  ข้อมูลจะถูกประมวลผลในประเทศไทย หากต้องมีการโอนข้อมูลไปต่างประเทศ จะดำเนินการตามกฎหมายและได้รับความยินยอมจากคุณก่อน 
                  </li>
                </ul>
                <h3>3. วิธีการ: </h3>
                <ul>
                  <li>
                  เราใช้ทั้งวิธีการอัตโนมัติและการประมวลผลด้วยมือเพื่อวิเคราะห์ข้อมูล ผลลัพธ์จะถูกนำเสนอในรูปแบบรวมที่ไม่สามารถระบุตัวบุคคลได้ 
                  </li>
                </ul>
                <h2>4. การจัดเก็บและรักษาข้อมูล </h2>
                <p>
                ข้อมูลส่วนบุคคลของคุณจะถูกจัดเก็บในประเทศไทย โดยเรามีมาตรการรักษาความปลอดภัยที่เข้มงวด หากมีการถ่ายโอนข้อมูลระหว่างประเทศ จะดำเนินการตามกฎหมายและได้รับความยินยอมจากคุณ 
                </p>
                <h2>5. สิทธิของคุณ </h2>
                <p>ภายใต้ PDPA คุณมีสิทธิดังนี้: </p>
                <ul>
                  <li>สิทธิในการเข้าถึง: ขอข้อมูลหรือรับสำเนาข้อมูลส่วนบุคคลของคุณ</li>
                  <li>สิทธิในการแก้ไข: ขอแก้ไขข้อมูลที่ไม่ถูกต้อง</li>
                  <li>สิทธิในการลบ: ขอให้ลบข้อมูลที่ไม่จำเป็น </li>
                  <li>สิทธิในการคัดค้าน: คัดค้านการประมวลผลข้อมูลที่ไม่ชอบด้วยกฎหมาย </li>
                  <li>ทธิในการเพิกถอนความยินยอม: เพิกถอนความยินยอมเมื่อใดก็ได้โดยไม่กระทบต่อการประมวลผลก่อนหน้านั้น </li>
                </ul>
                <p>
                สิทธิในการคัดค้าน: คัดค้านการประมวลผลข้อมูลที่ไม่ชอบด้วยกฎหมาย 
                </p>
                <h2>6. ผลกระทบหากไม่ให้ข้อมูล </h2>
                <p>
                การให้ข้อมูลเป็นไปโดยสมัครใจ แต่หากคุณไม่ให้ข้อมูล คุณจะไม่สามารถเข้าร่วมสำรวจหรือรับรางวัลได้ 
                </p>
                <h2>7. การใช้คุกกี้ </h2>
                <p>
                เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์ผู้ใช้งาน ข้อมูลที่เก็บรวบรวมจะไม่ระบุตัวบุคคลโดยตรง คุณสามารถตั้งค่าเบราว์เซอร์เพื่อปฏิเสธคุกกี้ได้ แต่บางฟีเจอร์อาจทำงานไม่สมบูรณ์ 
                </p>
                <p>ข้อมูลติดต่อ หากมีคำถามเกี่ยวกับนโยบายนี้ กรุณาติดต่อ: </p>
                <ul>
                  <li>บริษัท วินเทอร์ อีเจนซี่ จำกัด </li>
                  <li>
                    140 ถนนวิทยุ แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330{" "}
                  </li>
                  <li>อีเมล: pm_support@winter.co.th </li>
                  <li>โทรศัพท์: +66 (0) 2-254-6414 </li>
                </ul>
                <p><i>บังคับใช้: 15 มกราคม 2565</i> </p>
                <br />
                <br />


                <h2><u>นโยบายการจัดการกรณีข้อมูลรั่วไหล</u></h2>
                <h2>1. วัตถุประสงค์ เพื่อกำหนดขั้นตอนในการจัดการกรณีข้อมูลรั่วไหลที่รวบรวมผ่านหน้าระบบเก็บข้อมูลลูกค้า เพื่อให้มั่นใจว่าปัญหาถูกระบุและแก้ไขอย่างรวดเร็ว พร้อมลดผลกระทบต่อผู้ใช้บริการ </h2>
                <h2>2. ขอบเขต ข้อมูลที่ครอบคลุมในนโยบายนี้: </h2>
                <ul>
                  <li>ชื่อ </li>
                  <li>นามสกุล </li>
                  <li>เบอร์โทรศัพท์ </li>
                  <li>อีเมล </li>
                </ul>
                <h2>3. ขั้นตอนการจัดการเหตุการณ์ </h2>
                <h3>3.1 การตรวจสอบและระบุปัญหา </h3>
                <ul>
                  <li>ตรวจสอบความผิดปกติในระบบ เช่น การเข้าถึงที่ไม่ได้รับอนุญาต  </li>
                  <li>แจ้งผู้ดูแลระบบทันทีหากพบปัญหา  </li>
                </ul>
                <h3>3.2 การสกัดกั้น </h3>
                <ul>
                  <li>ปิดการเข้าถึงระบบที่ได้รับผลกระทบ </li>
                  <li>ตรวจสอบและแก้ไขช่องโหว่ที่อาจเป็นสาเหตุของปัญหา </li>
                </ul>
                <h3>3.3 การแจ้งเตือนลูกค้า </h3>
                <ul>
                  <li>แจ้งลูกค้าที่ได้รับผลกระทบ พร้อมให้ข้อมูล: </li>
                  <ul>
                    <li>รายละเอียดปัญหา </li>
                    <li>ขั้นตอนที่ดำเนินการเพื่อแก้ไข </li>
                  </ul>
                </ul>
                <h3>3.4 การฟื้นฟูระบบ </h3>
                <ul>
                  <li>ใช้ข้อมูลสำรองเพื่อคืนค่าระบบ  </li>
                  <li>อัปเดตระบบเพื่อป้องกันการเกิดซ้ำ  </li>
                </ul>
                <h2>4. มาตรการป้องกัน </h2>
                <ul>
                  <li>ใช้ระบบเข้ารหัสข้อมูล </li>
                  <li>จำกัดการเข้าถึงข้อมูลเฉพาะผู้ที่เกี่ยวข้อง </li>
                  <li>ตรวจสอบระบบเป็นประจำ </li>
                </ul>
                <h2>5. การปฏิบัติตามข้อกำหนด ดำเนินการให้สอดคล้องกับกฎหมายที่เกี่ยวข้อง เช่น พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) </h2>
                <h2>6. ผู้รับผิดชอบ บริษัท วินเทอร์ อีเจนซี่ จำกัด เป็นผู้ดูแลและรับผิดชอบในการจัดการกรณีข้อมูลรั่วไหลทั้งหมด </h2>
              </div>
              <div className="bBtn">
                <ButtonBack />
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
